import { Result } from "antd";

const Unauthorized = () => {
  return (
    <Result
      status="403"
      title="403 - Unauthorized"
      subTitle="Sorry, you don't have access to this page."
    />
  );
};

export default Unauthorized;
